<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

    <h2 style="padding: 100px">
      Welcome to ParkBills
    </h2>

  </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import helper from "@/components/Utility/Helper"

export default {
  name: "PageLanding",
  data () {
    return {
      permission : null,
      breadcrumb : null,
    }
  },
  components: {
    TemplateBasic,
    TemplateButton,
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }
  },
  methods: {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Page/PageLanding.vue